//#region ng
import { Component } from '@angular/core';
//#endregion

@Component({
  selector: 'me-html-pedidos-list-skel',
  templateUrl: './pedidos-list-skel.component.html',
  styleUrls: ['./pedidos-list-skel.component.scss']
})
export class MeHtmlPedidosListSkelComponent { }